export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-06.b6d543d2.jpg";